import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class DuplicatedProductApplicationIdException extends QuoteException {

}